import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";

export default function AuthCallback() {
  const { getToken } = useAuth();
  const { lang } = useLang();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");

    if (error) {
      navigate(`/login?error=${error}`);
      return;
    }

    if (getToken()) {
      navigate("/dashboard", { replace: true });
    } else {
      navigate("/login");
    }
  }, [getToken, navigate]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <p style={{ fontFamily: "sans-serif", color: "#9ca3af" }}>{lang.common.loading}</p>
    </div>
  );
}
